import { type WithingsOrderPostContentObjectDetail, createWithingsOrderPostContentObjectDetail } from 'models';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { useContentObjectCache } from 'features/feed/queries/cache';
import { createWithingsOrderPost } from '../../services';

type CreateWithingsOrderPostData = {
  htmlContent: string;
  programId: string;
  programTopicId: string;
  publishAt: Date;
  textContent: string;
  title?: string;
  todoDueDate?: Date;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
export const useCreateWithingsOrderPostMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<WithingsOrderPostContentObjectDetail, CreateWithingsOrderPostData>({
    async mutationFn({ htmlContent, programId, programTopicId, publishAt, textContent, title, todoDueDate }) {
      const createOrderPostResponse = await createWithingsOrderPost({
        htmlContent,
        programId,
        programTopicId,
        publishAt,
        textContent,
        title,
        todoDueDate,
      });

      return createWithingsOrderPostContentObjectDetail(createOrderPostResponse.data);
    },
    onSuccess(data) {
      cache.create(data);
    },
  });
};
